module.exports = __webpack_public_path__ + "img/help.4857fabc.png";